import React from 'react'

class TieupCell extends React.Component {
    render() {
        /*
        let cssClassName = 'reducer-tieup-cell ' + (this.props.cellData ? 'black' : 'white')
        if (this.props.toggleCellFunction) {
            return (<div className = {cssClassName} onClick = {this.props.toggleCellFunction}>●</div>)
        }
        else {
            return (<div className = {cssClassName}>●</div>)
        }
        */

        if (this.props.toggleCellFunction) {
            if (this.props.cellData) {
                return <div onClick = {this.props.toggleCellFunction} className='reducer-tieup-cell reducer-hand-cursor'>
                    <img alt='●' className='reducer-tieup-cell-image' src={require('../../../../images/black-sphere-128px.png')}/>
                </div>
            }
            else {
                return <div onClick = {this.props.toggleCellFunction} className='reducer-tieup-cell reducer-hand-cursor'>
                    <img alt=' ' className='reducer-tieup-cell-image' src={require('../../../../images/transparent-128px.png')}/>
                </div>
            }
        }
        else {
            if (this.props.cellData) {
                return <div className='reducer-tieup-cell'>
                    <img alt='●' className='reducer-tieup-cell-image' src={require('../../../../images/black-sphere-128px.png')}/>
                </div>
            }
            else {
                return <div className='reducer-tieup-cell'>
                    <img alt=' ' className='reducer-tieup-cell-image' src={require('../../../../images/transparent-128px.png')}/>
                </div>
            }
        }
    }
}

export default TieupCell




// WEBPACK FOOTER //
// ./src/scenes/reducer/components/TieupCell/index.js